import React from 'react';
import { Link } from 'react-router-dom';
import './Panchang.scss';

import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import TempleBuddhistOutlinedIcon from '@mui/icons-material/TempleBuddhistOutlined';
import StarIcon from '@mui/icons-material/Star';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';

const Panchang = ({ onClose }) => {
  return (
    <div className="modall-overlay" onClick={onClose}>
      <div className="modall-content" onClick={e => e.stopPropagation()}>
        <div className="panchang-container">
          <h2>PANCHANG</h2>
          <div className="panchang-grid">

            <Link to='/panchang/monthly' className="panchang-item">
              <EditCalendarIcon className="icon" />
              <div>
                <h4>Month</h4>
                <p>Monthly Panchang Overview</p>
              </div>
            </Link>

            <Link to='/panchang/dainik' className="panchang-item">
              <DashboardIcon className="icon" />
              <div>
                <h4>Dainik</h4>
                <p>Daily Panchang Details</p>
              </div>
            </Link>

            <Link to='/panchang/bengali' className="panchang-item">
              <LanguageOutlinedIcon className="icon" />
              <div>
                <h4>Bengali Panjika</h4>
                <p>Bengali Panchang Calendar</p>
              </div>
            </Link>

            <Link to='/panchang/english' className="panchang-item">
              <ArticleOutlinedIcon className="icon" />
              <div>
                <h4>English Panjika</h4>
                <p>English Panchang View</p>
              </div>
            </Link>

            <Link to='/panchang/iskcon' className="panchang-item">
              <TempleBuddhistOutlinedIcon className="icon" />
              <div>
                <h4>Vaishnav</h4>
                <p>Vaishnav Festival Calendar</p>
              </div>
            </Link>

            <Link to='/panchang/naksatra' className="panchang-item">
              <StarIcon className="icon" />
              <div>
                <h4>Tara</h4>
                <p>Today's Tara & Influence</p>
              </div>
            </Link>

            <Link to='/panchang/chandrabalam' className="panchang-item">
              <DarkModeOutlinedIcon className="icon" />
              <div>
                <h4>Chandrabalam</h4>
                <p>Moon Strength (Chandrabalam) Guide</p>
              </div>
            </Link>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Panchang;
